// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"507":"c805a221","956":"47f74fea"}[chunkId] + ".js";
};